var _defs, _g, _g2, _g3, _g4, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinalLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 141,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 245 175.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{clip-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#01b1ec;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:#f17134;}.cls-7{clip-path:url(#clip-path-3);}.cls-8{fill:#017dc5;}.cls-9{clip-path:url(#clip-path-4);}.cls-10{fill:#f8a51b;}.cls-11{font-size:40px;fill:#666;font-family:Nourd;font-weight:700;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-31.3 -22.36)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "87.47 22.27 187.22 22.27 187.42 41.7 87.67 41.7 87.47 22.27"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-31.3 -22.36)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 173.83,
    y: 22.23,
    width: 35.25,
    height: 96.75
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-31.3 -22.36)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 121.34,
    y: 46.2,
    width: 57,
    height: 99
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(-31.3 -22.36)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.67,
    y: 45.44,
    width: 42,
    height: 79.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.46,99.55c3.91-6.8,7.69-13.35,11.69-20.29l6.61,11.51c1.68,2.89,3.35,5.8,5.06,8.78Zm96.92-43.42c-5.28-20.48-22.8-33.67-43.95-33.68q-36.74,0-73.46,0l9.6,16.9q32-.06,63.88,0a27.37,27.37,0,0,1,18.69,6.75c8.31,7.27,10.84,16.72,9.73,27.32-1.26,12.28-9.32,22.58-20.31,25.22-4.66,1.13-9.67.68-14.5,1.17-2.74.28-4.13-.86-5.42-3.14C141.74,81,132.71,65.4,123.71,49.8c-1.64-2.85-3.43-2.88-5-.08l-7.16,12.4Q96.38,88.34,81.25,114.56c-.3.54-.51,1.13-.93,2.08h2.73c18.93,0,37.87,0,56.8-.07a4.4,4.4,0,0,1,3.11,1,5.88,5.88,0,0,1,1.32,1.69c4.94,8.74,10,17.42,15,26.15h19.59c-2.34-4.06-4.58-7.92-6.8-11.78q-4.74-8.24-9.43-16.42c.38-.3.49-.47.63-.48.57,0,1.15-.07,1.72-.09a44.14,44.14,0,0,0,23.63-8C206.17,96.56,211.11,74.51,206.38,56.13Z",
    transform: "translate(-31.3 -22.36)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.37,99.53l11.68-20.29,6.62,11.51,5.06,8.78Zm96.92-43.42c-5.28-20.48-22.8-33.67-44-33.68q-36.72,0-73.45,0l9.59,16.9q31.95-.06,63.89,0a27.36,27.36,0,0,1,18.69,6.74c8.31,7.28,10.83,16.73,9.73,27.33C189.52,85.65,181.46,96,170.47,98.6c-4.66,1.12-9.68.68-14.5,1.17-2.74.28-4.13-.86-5.42-3.14-8.9-15.66-17.94-31.25-26.93-46.85-1.64-2.85-3.43-2.88-5.05-.08l-7.16,12.4Q96.28,88.32,81.16,114.54c-.3.54-.51,1.13-.94,2.08H83c18.93,0,37.87,0,56.8-.07a4.4,4.4,0,0,1,3.11,1,5.9,5.9,0,0,1,1.31,1.69c4.95,8.74,10,17.42,15,26.15h19.59c-2.34-4.06-4.58-7.93-6.8-11.79q-4.74-8.22-9.44-16.41c.38-.3.5-.47.64-.48.56,0,1.14-.07,1.72-.09a44,44,0,0,0,23.62-8C206.08,96.54,211,74.49,206.29,56.11Z",
    transform: "translate(-31.3 -22.36)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M108.93,99.53c3.92-6.79,7.69-13.35,11.69-20.28l6.62,11.5c1.67,2.89,3.34,5.81,5.06,8.78Zm96.93-43.42c-5.28-20.48-22.81-33.67-44-33.68q-36.72,0-73.45,0L98,39.33q32-.06,63.89,0a27.39,27.39,0,0,1,18.69,6.74c8.31,7.28,10.73,16.71,9.73,27.32C189.16,86,181.07,96.46,170,98.6c-4.71.92-9.68.69-14.51,1.17-2.73.28-4.12-.85-5.41-3.13-8.9-15.66-17.94-31.25-26.93-46.85-1.64-2.85-3.43-2.88-5-.09L111,62.1Q95.85,88.34,80.73,114.55c-.31.53-.51,1.12-.94,2.07h2.74c18.93,0,37.86,0,56.8-.06a4.41,4.41,0,0,1,3.11,1,6,6,0,0,1,1.31,1.69c4.95,8.75,10,17.42,15,26.15h19.58c-2.33-4.06-4.57-7.92-6.79-11.78-3.17-5.48-6.31-11-9.44-16.42.38-.29.5-.46.63-.47a16.56,16.56,0,0,1,1.73-.1c8.71.07,16.5-3.07,23.62-8C205.65,96.55,210.59,74.5,205.86,56.11Z",
    transform: "translate(-31.3 -22.36)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M109.8,98c3.31-5.76,6.55-11.38,9.93-17.24a1,1,0,0,1,1.76,0c1.94,3.38,3.83,6.67,5.74,10L131.41,98a1,1,0,0,1-.88,1.52H110.68A1,1,0,0,1,109.8,98Zm96.05-41.9c-5.28-20.48-22.81-33.67-44-33.68q-35.85,0-71.72,0a1,1,0,0,0-.88,1.51l8.45,14.88a1,1,0,0,0,.88.51q31.65-.06,63.3,0A27.39,27.39,0,0,1,180.61,46c8.31,7.28,10.83,16.73,9.73,27.33C189.08,85.6,181,95.9,170,98.54c-4.66,1.13-9.68.68-14.51,1.17-2.73.28-4.12-.86-5.41-3.14-8.9-15.66-17.54-31.48-26.93-46.85-1.68-2.74-3.43-2.88-5.05-.08L111,62Q95.84,88.26,80.72,114.48a6.54,6.54,0,0,0-.32.65,1,1,0,0,0,.92,1.43h1.2c18.93,0,37.91.18,56.79-.07a4.42,4.42,0,0,1,3.12,1,6,6,0,0,1,1.31,1.69c4.85,8.57,9.81,17.08,14.69,25.64a1,1,0,0,0,.87.51h17.25a1,1,0,0,0,.88-1.53c-2-3.51-4-6.88-5.92-10.25q-4.75-8.23-9.44-16.42c.38-.3.5-.47.63-.48.57,0,1.15-.07,1.73-.09a44.11,44.11,0,0,0,23.62-8C205.63,96.48,210.58,74.43,205.85,56.05Z",
    transform: "translate(-31.3 -22.36)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(0 165.39)"
  }, "DivAuctions")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalLogo);
export default __webpack_public_path__ + "static/media/final-logo.c84f472406b2d9bcda0efc3f3a080eb9.svg";
export { ForwardRef as ReactComponent };